module.exports = __webpack_public_path__ + "img/facebook.6abea506.svg";